import React from 'react';
import PageBasic from '../templates/PageBasic';
import SpinnerCrimp from '../components/utilities/SpinnerCrimp';
var selfStyles = require('./styles.scss');
var PageLoading = function (props) {
    return (React.createElement(PageBasic, null,
        React.createElement("div", { className: selfStyles.wrapper },
            React.createElement(SpinnerCrimp, { size: 'large' }),
            props.loadMessage && React.createElement("span", { className: selfStyles.message }, props.loadMessage))));
};
export default PageLoading;



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageLoading/index.tsx
// module id = 1329
// module chunks = 0